module.exports = __webpack_public_path__ + "static/media/IMG-28.cbe8f731.jpg";